import { useI18n } from 'vue-i18n'
import { createNoty } from '@/libs/noty'

/**
 * Composable for displaying localized notifications.
 * Use noty(key, config) for i18n keys; use createNoty(text, config) directly for dynamic text (API errors, etc.).
 *
 * @returns {{ noty: (key: string, config?: object) => Promise<string> }}
 */
export function useNoty() {
  const { t } = useI18n()
  return {
    noty: (key, config = {}) => createNoty(t(key), config),
  }
}
